module.exports = __webpack_public_path__ + "static/media/search.cdad1593.svg";